import * as React from 'react'

/**
 * The shell-wide send gate (scope §5.0, P12). When the Desk mirror is stale (red liveness), the
 * API is unreachable, or the person has no working Desk token, every send box in the app is
 * replaced by the reason, whatever screen it is on. Screens never have to remember to check: the
 * ComposerShell reads this context itself. A screen-specific `blocked` prop still wins.
 */
export interface SendGate {
  /** True when nothing may be sent from this browser right now. */
  disabled: boolean
  /** Printed inside the send box ("Mirror stale; sends disabled"). */
  reason?: string
  /** An optional fix next to the reason (a Connect Desk link). */
  action?: React.ReactNode
}

const OPEN: SendGate = { disabled: false }
const Ctx = React.createContext<SendGate>(OPEN)

export function SendGateProvider({ value, children }: { value: SendGate; children: React.ReactNode }) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export function useSendGate(): SendGate {
  return React.useContext(Ctx)
}
